import React from 'react';
import styles from './KbSearchBar.module.css';

interface KbSearchBarProps {
  query?: string;
  onQueryChange?: (q: string) => void;
  selectedCategory?: string | null;
  onClearCategory?: () => void;
}

export const KbSearchBar: React.FC<KbSearchBarProps> = ({
  query = '',
  onQueryChange,
  selectedCategory,
  onClearCategory,
}) => {
  return (
    <div className={styles.bar}>
      <div className={styles.searchWrap}>
        <svg viewBox="0 0 24 24" fill="currentColor" className={styles.searchIcon}>
          <path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
        </svg>
        <input
          className={styles.input}
          placeholder="Search Help Articles..."
          value={query}
          onChange={(e) => onQueryChange?.(e.target.value)}
        />
      </div>
      <button
        type="button"
        className={styles.filter}
        onClick={() => onClearCategory?.()}
        disabled={!selectedCategory}
        title={selectedCategory ? `Clear filter (${selectedCategory})` : 'No category filter'}
      >
        <span>{selectedCategory ?? 'All Categories'}</span>
        <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
          <path d="M7 10l5 5 5-5z" />
        </svg>
      </button>
    </div>
  );
};
